// extracted by mini-css-extract-plugin
export var divider = "_tp-0";
export var systemMessage = "_tp-1";